

//logos
import logo1 from "./logos/logo1.jpg";
import logo2 from "./logos/logo2.jpg";
import logo3 from "./logos/logo3.jpg";
import logo4 from "./logos/logo4.jpg";
import logo5 from "./logos/logo5.jpg";
import logo6 from "./logos/logo6.jpg";
import logo7 from "./logos/logo7.jpg";
import logo8 from "./logos/logo8.jpg";
import logo9 from "./logos/logo9.jpg";
import logo10 from "./logos/logo10.jpg";
import logo11 from "./logos/logo11.jpg";
import logo12 from "./logos/logo12.jpg";
import logo13 from "./logos/logo13.jpg";
import logo14 from "./logos/logo14.jpg";
import logo15 from "./logos/logo15.jpg";
import logo16 from "./logos/logo16.jpg";
import logo17 from "./logos/logo17.jpg";
import logo18 from "./logos/logo18.jpg";
import logo19 from "./logos/logo19.jpg";
import logo20 from "./logos/logo20.jpg";
import logo21 from "./logos/logo21.jpg";
import logo22 from "./logos/logo22.jpg";
import logo23 from "./logos/logo23.jpg";
import logo24 from "./logos/logo24.jpg";
import logo25 from "./logos/logo25.jpg";
import logo26 from "./logos/logo26.jpg";
import logo27 from "./logos/logo27.jpg";
import logo28 from "./logos/logo28.jpg";
import logo29 from "./logos/logo29.jpg";
import logo30 from "./logos/logo30.jpg";
import logo31 from "./logos/logo31.jpg";
import logo32 from "./logos/logo32.jpg";
import logo33 from "./logos/logo33.jpg";
import logo34 from "./logos/logo34.jpg";
import logo35 from "./logos/logo35.jpg";
import logo36 from "./logos/logo36.jpg";

//menus
import menu1 from "./menus/menu1.jpg";
import menu2 from "./menus/menu2.jpg";
import menu3 from "./menus/menu3.jpg";
import menu4 from "./menus/menu4.jpg";
import menu5 from "./menus/menu5.jpg";
import menu6 from "./menus/menu6.jpg";
import menu7 from "./menus/menu7.jpg";
import menu8 from "./menus/menu8.jpg";
import menu9 from "./menus/menu9.jpg";
import menu10 from "./menus/menu10.jpg";

//games
import ui1 from "./games/ui1.jpg";
import ui3 from "./games/ui3.png";
import ui4 from "./games/ui4.jpg";
import ui5 from "./games/ui5.png";
import ui6 from "./games/ui6.jpg";
import ui7 from "./games/ui7.png";
import ui8 from "./games/ui8.jpg";
import ui9 from "./games/ui9.png";
import ui10 from "./games/ui10.jpg";
import ui11 from "./games/ui11.png";
import ui12 from "./games/ui12.jpg";
import ui13 from "./games/ui13.png";
import ui14 from "./games/ui14.jpg";
import ui15 from "./games/ui15.png";
import ui16 from "./games/ui16.jpg";
import ui17 from "./games/ui17.jpg";
import ui18 from "./games/ui18.jpg";
import ui19 from "./games/ui19.jpg";
import ui20 from "./games/ui20.jpg";
import ui21 from "./games/ui21.jpg";
import ui22 from "./games/ui22.jpg";
import ui23 from "./games/ui23.jpg";
import ui24 from "./games/ui24.jpg";
import ui25 from "./games/ui25.jpg";
import ui26 from "./games/ui26.jpg";
import ui27 from "./games/ui27.jpg";
import ui28 from "./games/ui28.jpg";
import ui29 from "./games/ui29.jpg";
import ui30 from "./games/ui30.jpg";
import ui31 from "./games/ui31.jpg";
import ui32 from "./games/ui32.jpg";
import ui33 from "./games/ui33.jpg";
import ui34 from "./games/ui34.jpg";
import ui35 from "./games/ui35.jpg";

// //misc
import granformato1 from "./misc/granformato1.jpg";
import granformato2 from "./misc/granformato2.jpg";
import granformato3 from "./misc/granformato3.jpg";
import granformato4 from "./misc/granformato4.jpg";
import granformato5 from "./misc/granformato5.jpg";
import granformato6 from "./misc/granformato6.jpg";
import granformato7 from "./misc/granformato7.jpg";
import granformato8 from "./misc/granformato8.jpg";
import granformato9 from "./misc/granformato9.jpg";
import granformato10 from "./misc/granformato10.jpg";
import granformato11 from "./misc/granformato11.jpg";
import misc1 from "./misc/misc1.jpg";
import misc2 from "./misc/misc2.jpg";
import misc3 from "./misc/misc3.jpg";
import misc4 from "./misc/misc4.jpg";
import misc5 from "./misc/misc5.jpg";
import misc8 from "./misc/misc8.jpg";
import misc9 from "./misc/misc9.jpg";
import package1 from "./misc/package1.png";
import package2 from "./misc/package2.jpg";
import package3 from "./misc/package3.jpg";
import package4 from "./misc/package4.jpg";
import package5 from "./misc/package5.jpg";

// //web
import web1 from "./web/web1.jpg";
import web2 from "./web/web2.jpg";
import web3 from "./web/web3.jpg";
import web4 from "./web/web4.jpg";
import web5 from "./web/web5.jpg";
import web6 from "./web/web6.jpg";
import web7 from "./web/web7.jpg";
import web8 from "./web/web8.jpg";
import web9 from "./web/web9.jpg";
import web10 from "./web/web10.jpg";
import web11 from "./web/web11.jpg";
import web12 from "./web/web12.jpg";
import web13 from "./web/web13.jpg";
import web14 from "./web/web14.jpg";
import web15 from "./web/web15.jpg";
import web16 from "./web/web16.jpg";
import web17 from "./web/web17.jpg";
import web18 from "./web/web18.jpg";
import web19 from "./web/web19.jpg";
import web20 from "./web/web20.jpg";
import web21 from "./web/web21.jpg";

// //print
import print1 from "./print/print1.jpg";
import print2 from "./print/print2.png";
import print3 from "./print/print3.jpg";
import print4 from "./print/print4.jpg";
import print5 from "./print/print5.jpg";
import print6 from "./print/print6.jpg";
import print7 from "./print/print7.jpg";
import print8 from "./print/print8.jpg";
import print9 from "./print/print9.jpg";
import print10 from "./print/print10.jpg";
import print11 from "./print/print11.jpg";
import print12 from "./print/print12.jpg";
import print13 from "./print/print13.jpg";
import print14 from "./print/print14.jpg";
import print15 from "./print/print15.jpg";
import print16 from "./print/print16.jpg";
import print17 from "./print/print17.jpg";
import print18 from "./print/print18.jpg";
import print19 from "./print/print19.jpg";
import print20 from "./print/print20.jpg";
import print21 from "./print/print21.jpg";
import print22 from "./print/print22.jpg";
import print23 from "./print/print23.jpg";
import print24 from "./print/print24.jpg";
import print25 from "./print/print25.jpg";
import print26 from "./print/print26.jpg";
import print27 from "./print/print27.jpg";
import print28 from "./print/print28.jpg";
import print29 from "./print/print29.jpg";
import print30 from "./print/print30.jpg";
import print31 from "./print/print31.jpg";
import print32 from "./print/print32.jpg";
import print33 from "./print/print33.jpg";
import print34 from "./print/print34.jpg";
import print35 from "./print/print35.jpg";
import print36 from "./print/print36.jpg";
import print37 from "./print/print37.jpg";
import print38 from "./print/print38.jpg";
import print39 from "./print/print39.jpg";
import print40 from "./print/print40.jpg";
import print41 from "./print/print41.jpg";
import print42 from "./print/print42.jpg";
import print43 from "./print/print43.jpg";
import print44 from "./print/print44.jpg";
import print45 from "./print/print45.jpg";



let portfolioImg = [
  {
    id: 1,
    imgSrc: misc1,
  },
  {
    id: 2,
    imgSrc: logo30,
  },
  {
    id: 3,
    imgSrc: web4,
  },
  {
    id: 4,
    imgSrc: print32,
  },
  {
    id: 5,
    imgSrc: logo22,
  },
  {
    id: 6,
    imgSrc: package5,
  },
  {
    id: 7,
    imgSrc: logo7,
  },
  {
    id: 8,
    imgSrc: menu9,
  },
  {
    id: 9,
    imgSrc: logo9,
  },
  {
    id: 10,
    imgSrc: logo10,
  },
  {
    id: 11,
    imgSrc: menu3,
  },
  {
    id: 12,
    imgSrc: package1,
  },
  {
    id: 13,
    imgSrc: print8,
  },
  {
    id: 14,
    imgSrc: print24,
  },
  {
    id: 15,
    imgSrc: logo17,
  },
  {
    id: 16,
    imgSrc: ui27,
  },
  {
    id: 17,
    imgSrc: print34,
  },
  {
    id: 18,
    imgSrc: logo8,
  },
  {
    id: 19,
    imgSrc: granformato9,
  },
  {
    id: 20,
    imgSrc: logo6,
  },
  {
    id: 21,
    imgSrc: ui17,
  },
  {
    id: 22,
    imgSrc: print38,
  },
  {
    id: 23,
    imgSrc: logo11,
  },
  {
    id: 24,
    imgSrc: logo3,
  },
  {
    id: 25,
    imgSrc: web13,
  },
  {
    id: 26,
    imgSrc: logo26,
  },
  {
    id: 27,
    imgSrc: granformato8,
  },
  {
    id: 28,
    imgSrc: logo23,
  },
  {
    id: 29,
    imgSrc: print9,
  },
  {
    id: 30,
    imgSrc: granformato7,
  },
  {
    id: 31,
    imgSrc: logo31,
  },
  {
    id: 32,
    imgSrc: print38,
  },
  {
    id: 33,
    imgSrc: logo33,
  },
  {
    id: 34,
    imgSrc: ui1,
  },
  {
    id: 35,
    imgSrc: logo34,
  },
  {
    id: 36,
    imgSrc: print5,
  },
  {
    id: 37,
    imgSrc: web8,
  },
  {
    id: 38,
    imgSrc: logo35,
  },
  {
    id: 39,
    imgSrc: print37,
  }
];

let logosImg = [
  {
    id: 1,
    imgSrc: logo1,
  },
  {
    id: 2,
    imgSrc: logo2,
  },
  {
    id: 3,
    imgSrc: logo3,
  },
  {
    id: 4,
    imgSrc: logo4,
  },
  {
    id: 5,
    imgSrc: logo5,
  },
  {
    id: 6,
    imgSrc: logo6,
  },
  {
    id: 7,
    imgSrc: logo7,
  },
  {
    id: 8,
    imgSrc: logo8,
  },
  {
    id: 9,
    imgSrc: logo9,
  },
  {
    id: 10,
    imgSrc: logo10,
  },
  {
    id: 11,
    imgSrc: logo11,
  },
  {
    id: 12,
    imgSrc: logo12,
  },
  {
    id: 13,
    imgSrc: logo13,
  },
  {
    id: 14,
    imgSrc: logo14,
  },
  {
    id: 15,
    imgSrc: logo15,
  },
  {
    id: 16,
    imgSrc: logo16,
  },
  {
    id: 17,
    imgSrc: logo17,
  },
  {
    id: 18,
    imgSrc: logo18,
  },
  {
    id: 19,
    imgSrc: logo19,
  },
  {
    id: 20,
    imgSrc: logo20,
  },
  {
    id: 21,
    imgSrc: logo21,
  },
  {
    id: 22,
    imgSrc: logo22,
  },
  {
    id: 23,
    imgSrc: logo23,
  },
  {
    id: 24,
    imgSrc: logo24,
  },
  {
    id: 25,
    imgSrc: logo25,
  },
  {
    id: 26,
    imgSrc: logo26,
  },
  {
    id: 27,
    imgSrc: logo27,
  },
  {
    id: 28,
    imgSrc: logo28,
  },
  {
    id: 29,
    imgSrc: logo29,
  },
  {
    id: 30,
    imgSrc: logo30,
  },
  {
    id: 31,
    imgSrc: logo31,
  },
  {
    id: 32,
    imgSrc: logo32,
  },
  {
    id: 33,
    imgSrc: logo33,
  },
  {
    id: 34,
    imgSrc: logo34,
  },
  {
    id: 35,
    imgSrc: logo35,
  },
  {
    id: 36,
    imgSrc: logo36,
  },
];

let menusImg = [
  {
    id: 1,
    imgSrc: menu1,
  },
  {
    id: 2,
    imgSrc: menu2,
  },
  {
    id: 3,
    imgSrc: menu3,
  },
  {
    id: 4,
    imgSrc: menu4,
  },
  
  {
    id: 6,
    imgSrc: menu6,
  },
  {
    id: 7,
    imgSrc: menu7,
  },
  {
    id: 8,
    imgSrc: menu8,
  },
  {
    id: 9,
    imgSrc: menu9,
  },
  {
    id: 10,
    imgSrc: menu10,
  },
];

let miscImg = [
  {
    id: 1,
    imgSrc: misc1,
  },
  {
    id: 2,
    imgSrc: misc2,
  },
  {
    id: 3,
    imgSrc: misc3,
  },
  {
    id: 4,
    imgSrc: misc4,
  },
  {
    id: 5,
    imgSrc: misc5,
  },
  {
    id: 8,
    imgSrc: misc8,
  },
  {
    id: 9,
    imgSrc: misc9,
  },
  {
    id: 10,
    imgSrc: granformato1,
  },
  {
    id: 11,
    imgSrc: granformato2,
  },
  {
    id: 12,
    imgSrc: granformato3,
  },
  {
    id: 13,
    imgSrc: granformato4,
  },
  {
    id: 14,
    imgSrc: granformato5,
  },
  {
    id: 15,
    imgSrc: granformato6,
  },
  {
    id: 16,
    imgSrc: granformato7,
  },
  {
    id: 17,
    imgSrc: granformato8,
  },
  {
    id: 18,
    imgSrc: granformato9,
  },
  {
    id: 19,
    imgSrc: granformato10,
  },
  {
    id: 20,
    imgSrc: granformato11,
  },
  {
    id: 21,
    imgSrc: package1,
  },
  {
    id: 22,
    imgSrc: package2,
  },
  {
    id: 23,
    imgSrc: package3,
  },
  {
    id: 24,
    imgSrc: package4,
  },
  {
    id: 25,
    imgSrc: package5,
  },
];

let webImg = [
  {
    id: 1,
    imgSrc: web1,
  },
  {
    id: 2,
    imgSrc: web2,
  },
  {
    id: 3,
    imgSrc: web3,
  },
  {
    id: 4,
    imgSrc: web4,
  },
  {
    id: 5,
    imgSrc: web5,
  },
  {
    id: 6,
    imgSrc: web6,
  },
  {
    id: 7,
    imgSrc: web7,
  },
  {
    id: 8,
    imgSrc: web8,
  },
  {
    id: 9,
    imgSrc: web9,
  },
  {
    id: 10,
    imgSrc: web10,
  },
  {
    id: 11,
    imgSrc: web11,
  },
  {
    id: 12,
    imgSrc: web12,
  },
  {
    id: 13,
    imgSrc: web13,
  },
  {
    id: 14,
    imgSrc: web14,
  },
  {
    id: 15,
    imgSrc: web15,
  },
  {
    id: 16,
    imgSrc: web16,
  },
  {
    id: 17,
    imgSrc: web17,
  },
  {
    id: 18,
    imgSrc: web18,
  },
  {
    id: 19,
    imgSrc: web19,
  },
  {
    id: 20,
    imgSrc: web20,
  },
  {
    id: 21,
    imgSrc: web21,
  },
];

let printImg = [
  {
    id: 1,
    imgSrc: print1,
  },
  {
    id: 2,
    imgSrc: print2,
  },
  {
    id: 3,
    imgSrc: print3,
  },
  {
    id: 4,
    imgSrc: print4,
  },
  {
    id: 5,
    imgSrc: print5,
  },
  {
    id: 6,
    imgSrc: print6,
  },
  {
    id: 7,
    imgSrc: print7,
  },
  {
    id: 8,
    imgSrc: print8,
  },
  {
    id: 9,
    imgSrc: print9,
  },
  {
    id: 10,
    imgSrc: print10,
  },
  {
    id: 11,
    imgSrc: print11,
  },
  {
    id: 12,
    imgSrc: print12,
  },
  {
    id: 13,
    imgSrc: print13,
  },
  {
    id: 14,
    imgSrc: print14,
  },
  {
    id: 15,
    imgSrc: print15,
  },
  {
    id: 16,
    imgSrc: print16,
  },
  {
    id: 17,
    imgSrc: print17,
  },
  {
    id: 18,
    imgSrc: print18,
  },
  {
    id: 19,
    imgSrc: print19,
  },
  {
    id: 20,
    imgSrc: print20,
  },
  {
    id: 21,
    imgSrc: print21,
  },
  {
    id: 22,
    imgSrc: print22,
  },
  {
    id: 23,
    imgSrc: print23,
  },
  {
    id: 24,
    imgSrc: print24,
  },
  {
    id: 25,
    imgSrc: print25,
  },
  {
    id: 26,
    imgSrc: print26,
  },
  {
    id: 27,
    imgSrc: print27,
  },
  {
    id: 28,
    imgSrc: print28,
  },
  {
    id: 29,
    imgSrc: print29,
  },
  {
    id: 30,
    imgSrc: print30,
  },
  {
    id: 31,
    imgSrc: print31,
  },
  {
    id: 32,
    imgSrc: print32,
  },
  {
    id: 33,
    imgSrc: print33,
  },
  {
    id: 34,
    imgSrc: print34,
  },
  {
    id: 35,
    imgSrc: print35,
  },
  {
    id: 36,
    imgSrc: print36,
  },
  {
    id: 37,
    imgSrc: print37,
  },
  {
    id: 38,
    imgSrc: print38,
  },
  {
    id: 39,
    imgSrc: print39,
  },
  {
    id: 40,
    imgSrc: print40,
  },
  {
    id: 41,
    imgSrc: print41,
  },
  {
    id: 42,
    imgSrc: print42,
  },
  {
    id: 43,
    imgSrc: print43,
  },
  {
    id: 44,
    imgSrc: print44,
  },
  {
    id: 45,
    imgSrc: print45,
  },
];

let gamesImg = [
  {
    id: 1,
    imgSrc: ui1,
  },
  {
    id: 3,
    imgSrc: ui3,
  },
  {
    id: 4,
    imgSrc: ui4,
  },
  {
    id: 5,
    imgSrc: ui5,
  },
  {
    id: 6,
    imgSrc: ui6,
  },
  {
    id: 7,
    imgSrc: ui7,
  },
  {
    id: 8,
    imgSrc: ui8,
  },
  {
    id: 9,
    imgSrc: ui9,
  },
  {
    id: 10,
    imgSrc: ui10,
  },
  {
    id: 11,
    imgSrc: ui11,
  },
  {
    id: 12,
    imgSrc: ui12,
  },
  {
    id: 13,
    imgSrc: ui13,
  },
  {
    id: 14,
    imgSrc: ui14,
  },
  {
    id: 15,
    imgSrc: ui15,
  },
  {
    id: 16,
    imgSrc: ui16,
  },
  {
    id: 17,
    imgSrc: ui17,
  },
  {
    id: 18,
    imgSrc: ui18,
  },
  {
    id: 19,
    imgSrc: ui19,
  },
  {
    id: 20,
    imgSrc: ui20,
  },
  {
    id: 21,
    imgSrc: ui21,
  },
  {
    id: 22,
    imgSrc: ui22,
  },
  {
    id: 23,
    imgSrc: ui23,
  },
  {
    id: 24,
    imgSrc: ui24,
  },
  {
    id: 25,
    imgSrc: ui25,
  },
  {
    id: 26,
    imgSrc: ui26,
  },
  {
    id: 27,
    imgSrc: ui27,
  },
  {
    id: 28,
    imgSrc: ui28,
  },
  {
    id: 29,
    imgSrc: ui29,
  },
  {
    id: 30,
    imgSrc: ui30,
  },
  {
    id: 31,
    imgSrc: ui31,
  },
  {
    id: 32,
    imgSrc: ui32,
  },
  {
    id: 33,
    imgSrc: ui33,
  },
  {
    id: 34,
    imgSrc: ui34,
  },
  {
    id: 35,
    imgSrc: ui35,
  },
];

export {
  
  portfolioImg,
  logosImg,
  menusImg,
  miscImg,
  webImg,
  printImg,
  gamesImg,
};
